// Why a pit is marked during a move animation: a stone was sown into it, stones were captured from it, the last stone
// landed in a store, or the player picked it and the move is on its way to the server.
export type PitHighlight = "sow" | "capture" | "store" | "selected";

export class PitViewModel {
  id: string;
  stoneCount: number;
  stoneColor: string;
  pitColor: string;
  highlight?: PitHighlight;

  constructor(
    id: string,
    stoneCount: number,
    stoneColor: string,
    pitColor: string,
    highlight?: PitHighlight
  ) {
    this.id = id;
    this.stoneCount = stoneCount;
    this.stoneColor = stoneColor;
    this.pitColor = pitColor;
    this.highlight = highlight;
  }
}